<form #resetPasswordForm="ngForm" class="auth-form" (ngSubmit)="resetPasswordForm.form.valid && resetPassword()">
  <h1>Reset Password</h1>
  <div>
    <div id="orange_separator"></div>
  </div>
  <p *ngIf="success" class="alert alert-success">
    Successfully updated.<br>
    <a href="/login">Click here to login.</a>
  </p>
  <div *ngIf="!success">
    <app-copyable-message *ngIf="error" variant="danger" extraClass="mb-3" [message]="error"></app-copyable-message>
    <div class="field">
      <label class="required" for="reset-password">Password</label>
      <input type="password" id="reset-password" placeholder="New password" autocomplete="new-password"
        [(ngModel)]="password" class="form-control" bkInput name="password" required />
    </div>
    <div class="field">
      <label class="required" for="reset-confirm">Confirm Password</label>
      <input type="password" id="reset-confirm" placeholder="Re-enter new password" autocomplete="new-password"
        [(ngModel)]="confirm_password" class="form-control" bkInput name="confirm_password" required />
    </div>
    <button bkButton color="primary" size="lg" block [disabled]="loading" [loading]="loading">Update</button>
    <p class="text-end auth-back">
      <a href="/login">Back to Login</a>
    </p>
  </div>
</form>
